import { AfterViewInit, CUSTOM_ELEMENTS_SCHEMA, Component, OnInit, ViewChild } from "@angular/core";
import {
  NavController,
  NavParams,
  AlertController,
  ModalController,
  ActionSheetController,
  IonicModule,
} from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { GrupoAdmImagemAddPage } from "../grupo-adm-imagem-add/grupo-adm-imagem-add.page";
import { GrupoProvider } from "src/app/services/grupo/grupo";
import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { ImagePipe } from "src/app/pipes/image/image";
import { CropperComponent } from "src/app/components/cropper/cropper.component";
import { register } from "swiper/element/bundle";
import { SemRegistroComponent } from "src/app/components/sem-registro/sem-registro";
import { LoadingSpinnerComponent } from "src/app/components/loading/loading-spinner/loading-spinner.component";
import { Capacitor, registerPlugin } from "@capacitor/core";

const PhotoEditorPlugin = registerPlugin<{
  edit(options: { imagePath: string }): Promise<{ base64: string }>;
}>("PhotoEditorPlugin");

register();
@Component({
  selector: "app-grupo-adm-imagem",
  templateUrl: "./grupo-adm-imagem.page.html",
  styleUrls: ["./grupo-adm-imagem.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ImagePipe,
    TranslateModule,
    CropperComponent,
    SemRegistroComponent,
    LoadingSpinnerComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class GrupoAdmImagemPage implements OnInit, AfterViewInit {
  @ViewChild("swiperElement", { static: false }) swiperElementRef!: any;
  idGrupo: string = "";
  imageList: any = [];
  readOnly: boolean = false;
  entidade: any;
  loaded = false;
  public path: string | undefined;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public alertCtrl: AlertController,
    public translate: TranslateService,
    public modalCtrl: ModalController,
    public grupoProvider: GrupoProvider,
    public actionSheetCtrl: ActionSheetController
  ) {
    this.idGrupo = this.navParams.get("idGrupo");
    this.readOnly = this.navParams.get("readOnly");
    this.entidade = this.navParams.get("entidade");
    this.grupoProvider.getFotoReuniao(this.entidade, this.idGrupo).subscribe((data) => {
      this.imageList = data;

      setTimeout(() => (this.loaded = true), 1000);
    });
  }

  ngAfterViewInit(): void {
    const swiperEl = this.swiperElementRef?.nativeElement;
    if (swiperEl) {
      swiperEl.initialize?.();
    }
  }

  ngOnInit() {}

  async getImage(source: CameraSource): Promise<void> {
    try {
      const { path } = await Camera.getPhoto({
        quality: 100,
        resultType: CameraResultType.Uri,
        presentationStyle: 'popover',
        source,
      });

      this.path = path;
      if (!this.path) {
        console.warn("Imagem não foi capturada corretamente.");
        return;
      }

      if (Capacitor.getPlatform() === "ios") {
        await this.openEditorWithImage(this.path);
      } else {
        this.openCameraAndCrop(this.path);
      }
    } catch (error) {
      console.error(`Erro ao obter imagem da ${source === CameraSource.Camera ? "câmera" : "galeria"}:`, error);
    }
  }

  async openEditorWithImage(path: string) {
    try {
      const result = await PhotoEditorPlugin.edit({
        imagePath: path,
      });

      if (result.base64) {
        await this.uploadAndRefresh(result.base64);
      }
    } catch (error) {
      console.error("Erro ao editar imagem:", error);
    }
  }

  async openCameraAndCrop(imageBase64: any) {
    const modal = await this.modalCtrl.create({
      component: CropperComponent,
      componentProps: { imageBase64 },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      this.loaded = false;
      await this.uploadAndRefresh(data);
    }
  }

  private async uploadAndRefresh(base64Image: string) {
    try {
      await this.grupoProvider.updateFoto(base64Image, this.idGrupo, this.entidade).toPromise();
      const data = await this.grupoProvider.getFotoReuniao(this.entidade, this.idGrupo).toPromise();

      this.imageList = data;
      setTimeout(() => {
        const swiperEl = this.swiperElementRef?.nativeElement;
        swiperEl?.initialize?.();
        this.loaded = true;
      }, 1000);
    } catch (error) {
      console.error("Erro ao atualizar ou buscar fotos:", error);
    }
  }

  async removerFoto(id: any) {
    let confirmAlert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: this.translate.instant("Atenção"),
      message: this.translate.instant("Deseja realmente essa imagem?"),
      buttons: [
        {
          text: this.translate.instant("Não"),
          role: "cancel",
        },
        {
          text: this.translate.instant("Sim"),
          handler: () => {
            this.grupoProvider.removerImagem(id).subscribe((data) => {
              this.grupoProvider.getFotoReuniao(this.entidade, this.idGrupo).subscribe((data) => {
                this.imageList = data;
                const swiperEl = this.swiperElementRef?.nativeElement;
                swiperEl?.initialize?.();
              });
            });
          },
        },
      ],
    });

    confirmAlert.present();
  }

  async openImg(imageList: any) {
    const data = {
      imageList: imageList,
      idGrupo: this.idGrupo,
      entidade: this.entidade,
    };

    const modal = await this.modalCtrl.create({
      component: GrupoAdmImagemAddPage,
      componentProps: data,
      keyboardClose: true,
      showBackdrop: true,
    });

    modal.present();

    const image = await modal.onDidDismiss();
    if (image.data) {
      this.loaded = false;

      this.imageList = image.data;
      setTimeout(() => {
        this.loaded = true;
      }, 1000);
    }
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  async foto() {
    await Camera.requestPermissions();
    const actionSheet = await this.actionSheetCtrl.create({
      buttons: [
        {
          text: "Tirar foto",
          data: {
            action: "takePhoto",
          },
          handler: () => {
            this.getImage(CameraSource.Camera);
          },
        },
        {
          text: "Escolher foto",
          data: {
            action: "choosePhoto",
          },
          handler: () => {
            this.getImage(CameraSource.Photos);
          },
        },
        {
          text: "Cancelar",
          role: "cancel",
          data: {
            action: "cancel",
          },
        },
      ],
    });

    actionSheet.present();
  }
}
